<!--This component (step 6) to confirm reservation-->
<template>
  <div class="my-16 py-16 text-center">
    <div class="my-5">
      <v-alert v-if="lastStepMsg && lastStepMsg[language]" class="mx-16 mb-10" color="info" outlined>
        <div v-html="lastStepMsg[language]"></div>
      </v-alert>

      <div>
        <p>
          {{ $t("generic.lang_order_successfull_msg") }} {{ datum }}
          {{ $t("generic.lang_with") }} {{ time }} .
        </p>
        <p class="subtitle-2">
          {{ $t("generic.lang_for") }} {{ numberPersons }}
          {{ $t("generic.lang_people") }} ({{ reservationTypeName }}).
        </p>
      </div>

      <!--Start Confirm Button-->
      <div class="my-16 text-center">
        <v-btn
          color="accent"
          tile
          x-large
          outlined
          :disabled="overlay"
          @click="createReservation()"
        >
          {{ $t("generic.lang_confirm_booking") }}
        </v-btn>

        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="80"></v-progress-circular>
        </v-overlay>
      </div>
      <!--End Confirm Button-->

      <!--Start cancel and edit Button-->
      <div class="d-flex mx-auto">
        <div class="mx-auto d-flex">
          <div class="mr-3">
            <v-btn
              class="ma-2"
              outlined
              fab
              text
              dark
              color="info"
              @click="editBtn()"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <p>{{ $t("generic.lang_edit") }}</p>
          </div>

          <div class="ml-3">
            <v-btn
              class="ma-2"
              outlined
              fab
              text
              dark
              color="error"
              @click="cancelBtn()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <p>{{ $t("generic.lang_cancel") }}</p>
          </div>
        </div>
      </div>
      <!--End cancel and edit Button-->
    </div>
  </div>
</template>

<script>
/*import plugins*/
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

export default {
  name: "Step6Component",

  data: () => ({
    overlay: false,
    datum: new Date(),
  }),

  computed: {
    //map loader getters
    ...createNamespacedHelpers("reservationTypes").mapState([
      "numberPersons",
      "reservationTypeName",
    ]),
    ...createNamespacedHelpers("dateTime").mapState(["date", "time"]),
    ...createNamespacedHelpers("config").mapGetters(["lastStepMsg"]),

    language() {
      return this.$i18n.locale;
    },
  },

  mounted() {
    if (this.language == "de") {
      this.datum = moment(this.date).format("DD.MM.YYYY");
    } else {
      this.datum = moment(this.date).format("YYYY.MM.DD");
    }
  },

  watch: {
    language(val) {
      if (val == "de") {
        this.datum = moment(this.date).format("DD.MM.YYYY");
      } else {
        this.datum = moment(this.date).format("YYYY.MM.DD");
      }
    },
  },

  methods: {
    createReservation() {
      this.overlay = true;

      var items = [];
      this.$store.state.items.selectedItems.forEach((selectedItem) => {
        items.push({
          id: selectedItem.itemId,
          quantity: selectedItem.itemQuantity,
        });
      });

      var promise = new Promise((resolve, reject) => {
        window
          .axios({
            url: "/",
            method: "POST",
            headers: {
              contentType: "application/json",
            },
            data: {
              new_customer: {
                salutation: this.$store.state.customerData.salutation,
                first_name: this.$store.state.customerData.first_name,
                last_name: this.$store.state.customerData.last_name,
                email: this.$store.state.customerData.email,
                phone: this.$store.state.customerData.phone,
              },
              type_uuid: this.$store.state.reservationTypes.reservationTypeUuid,
              note: this.$store.state.customerData.note,
              attachment: this.$store.state.customerData.attachment.value,
              time: this.$store.state.dateTime.time,
              date: this.$store.state.dateTime.date,
              person: this.$store.state.reservationTypes.numberPersons,
              tables: this.$store.state.tables.tables,
              items: items,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      });

      promise
        .then((response) => {
          window.indexedDB.deleteDatabase("localforage");

          localStorage.setItem("orderUuid", response.data.data.uuid);

          this.$router.push("/booking-receipt");
        })
        .catch(() => {
          this.$swal({
            title: this.$t("generic.lang_error"),
            icon: "error",
            text: this.$t("generic.lang_time_slot_fully_booked"),
            //text: err.response.data.message,
          });
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    cancelBtn() {
      window.indexedDB.deleteDatabase("localforage");
      window.location.reload();
    },

    editBtn() {
      this.$emit("edit");
    },
  },
};
</script>
